import React from 'react';

import { Label } from 'flowbite-react';

interface Props {
  readonly header: string;
  readonly subHeader: string;
  readonly openModal?: (type: any) => void
}

function BioLabel({
    header,
    subHeader,
    openModal = (_) => {},
}: Props) {
    return (
        <div className="self-start sm:min-w-[200px]">
            <Label
                className="text-gray-700 font-instrument-sans text-base font-semibold leading-6"
                value={header}
            />
            <p>
                {subHeader}
                {' '}
                {openModal && <button type="button" className="text-progressBarBlue" onClick={() => openModal(true)}>How do I do this?</button>}
            </p>

        </div>
    );
}

export default BioLabel;
